<script>
import {ConcernElements} from "@/views/product/components/product-card";
import Overlay from "@core/components/common/Overlay.vue";

export default {
    components: {Overlay, ConcernElements},
    props: {
        product: {
            required: true
        },
        legislations: {
            required: true,
            default() {
                return [];
            }
        },
        includedSubstances: {
            default() {
                return [];
            }
        },
        excludedSubstances: {
            default() {
                return [];
            }
        },
        loading: {
            default: false
        }
    },

    data() {
        return {
            showLoading: true
        }
    },

    computed: {
        autoExpandLists() {
            return this.legislations.length === 1;
        },
        autoExpandSubstances() {
            return this.legislations.length === 1;
        }
    },
}
</script>

<template>
    <Overlay :show="showLoading || loading">
        <ConcernElements
            :product="product"
            :show-information-owner-settings="false"
            :company-has-information="true"
            :legislations="legislations"
            :show-instruction="true"
            :show-questions="true"
            :read-only-for-included="true"
            :included-radio-disabled="true"
            :included-radio-title="$t('Page(ReceivedRequestFMDFlow):Component(Label):included-radio-title')"
            :auto-expand-lists="autoExpandLists"
            :auto-expand-substances="autoExpandSubstances"
            :automaticallySyncIncludedSubstances="true"
            container-class=""
            :included-substances="includedSubstances"
            :excluded-substances="excludedSubstances"
            @include="(s) => $emit( 'include', s)"
            @exclude="(s) => $emit( 'exclude', s)"
            @undefined="(s) => $emit( 'undefined', s)"
            @loaded="showLoading = false"
            @listQuestionStateUpdated="$emit( 'listQuestionStateUpdated', $event)"
        />
    </Overlay>
</template>
